let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("BZsiM")).then(() => parcelRequire('aq3KW'));